module.exports = __webpack_public_path__ + "static/CalibreWeb-Light-ea02410b3ecf6c3358e20d581f986f2d.woff";